const idsWithoutImages = [5957, 7160, 9449, 26906, 26925];
export default idsWithoutImages;
